import { render, staticRenderFns } from "./Ipoints.vue?vue&type=template&id=4351fc0e&scoped=true&"
import script from "./Ipoints.vue?vue&type=script&lang=js&"
export * from "./Ipoints.vue?vue&type=script&lang=js&"
import style0 from "./Ipoints.vue?vue&type=style&index=0&id=4351fc0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4351fc0e",
  null
  
)

export default component.exports